export const PREFIXED_AUTH = "/auth/v1";
export const PREFIXED_SOCIAL = "/social/v1";

export const PREFIXED_TRACKER = "/tracker/v1";

//******************************************** */
//INIT_SETTING

export const INIT_API = "/platform/v1/init";

//******************************************** */
//SIGN-IN

export const SUBMIT_PHONE = `${PREFIXED_AUTH}/init`;
export const SUBMIT_OTP = `${PREFIXED_AUTH}/login/otp`;
export const REFRESH_TOKEN = `${PREFIXED_AUTH}/refresh`;
export const LOGOUT = (udid: string) => `${PREFIXED_AUTH}/logout?UDID=${udid}`;

//******************************************** */
//DEVICE URL

export const GET_DEVICE_URL = (id: string) => `/platform/v1/versions?app_id=${id}`;

export const SEND_DEVICE_INFO = `${PREFIXED_TRACKER}/device-info`;

//******************************************** */
// SUPER APP TRANSFER TOKEN

export const GET_TRANSFER_TOKEN = "auth/v1/sso/users/tokens";
//******************************************** */
// SUPER APP BANNER
export const GET_BANNER = "/banner/v1/banners";
export const UNREAD_COUNT = "/chat/v1/conversations/unread-count";
//******************************************** */
// CALL INIT
export const CALL_INIT = "/social/v1/init";
